import { createMiddleware } from "@tanstack/react-start";
import { getRequest } from "@tanstack/react-start/server";
import { assertWireValues } from "../../../api/src/db/wire";

/** Check the server function's value before Start's serializer can preserve a Date or bigint. */
export const wireValues = createMiddleware({ type: "function" }).server(
  async ({ next, context }) => {
    const response = await next();
    // Start 1.x carries the handler value as result in executeMiddleware; its public middleware
    // type exposes only context. Keep the checked value unknown at this boundary.
    const value = (response as unknown as { result?: unknown }).result;
    if (!(value instanceof Response))
      assertWireValues(
        value,
        new URL(getRequest().url).pathname,
        context.env.ENVIRONMENT !== "local",
      );
    return response;
  },
);
